import React from 'react';
import classNames from 'classnames';

interface LoadingProps {
	size?: number | string;
	color?: string;
	className?: string;
}

const Loading: React.FC<LoadingProps> = ({ size = 200, color = '#6c5dd3', className }) => {
	const finalSize = typeof size === 'number' ? `${size}px` : size;

	return (
		<div
			className={classNames(
				'd-flex flex-column align-items-center justify-content-center h-100 w-100',
				className,
			)}>
			<svg
				viewBox='0 0 24 24'
				fill='currentColor'
				style={{
					width: finalSize,
					height: finalSize,
					color,
					overflow: 'visible',
					zIndex: 1000,
				}}>
				<path fill='none' d='M0 0h24v24H0z' />

				{/* Star 1: Main solid star with subtle scale sparkle */}
				<g className='star star-1'>
					<path d='M11.5 9.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5z' />
					<path d='M9.99 14.99L9 15.17l-.99-2.18L5.83 12l2.18-.99L9 8.83l.99 2.18 2.18.99-2.18.99z' />
				</g>

				{/* Star 2: Top-left burst, semi-transparent */}
				<path
					className='star star-2'
					d='M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25z'
				/>

				{/* Star 3: Bottom-right burst, semi-transparent */}
				<path
					className='star star-3'
					d='M19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25z'
				/>

				<style>{`
					.star {
						transform-origin: center;
					}
					
					.star-1 {
						animation: sparkleStarMain 1.6s ease-in-out infinite;
					}
					
					.star-2, .star-3 {
						opacity: 0.5;
						animation: sparkleStarSecondary 1.2s ease-in-out infinite;
					}
					
					.star-2 {
						animation-delay: 0.2s;
					}
					
					.star-3 {
						animation-delay: 0.4s;
					}

					@keyframes sparkleStarMain {
						0%, 100% { transform: scale(1); }
						50% { transform: scale(1.1); }
					}

					@keyframes sparkleStarSecondary {
						0%, 100% { transform: scale(1); opacity: 0.5; }
						50% { transform: scale(1.3); opacity: 0.8; }
					}
				`}</style>
			</svg>
		</div>
	);
};

export default Loading;
